

import React, { useEffect, useState } from 'react';
import { Animated, StyleSheet } from 'react-native';
import { CREATE_USER_EVENT } from '../../../../state/mutations/UserEvent';
import { LinearGradient } from 'expo-linear-gradient';

import { ExerciceCircle } from '../../../../components/BreatheExercise/ExerciceCircle';
import { ExerciceComplete } from '../../../../components/BreatheExercise/ExerciceComplete';
import { ExerciceInterlude } from '../../../../components/BreatheExercise/ExerciceInterlude';
import { ExerciceTimer, buttonSize } from '../../../../components/BreatheExercise/ExerciceTimer';
import { HEIGHT_BOTTOM_TAB_BAR } from '../../_layout';
import { LEFT_BREATHING_COLORS, RIGHT_BREATHING_COLORS } from '../../../../config/designSystem/Colors';
import { SoundHandle, playSound, preloadSound } from '../../../../utils/sound/sound';
import { StatusBar } from 'expo-status-bar';
import { animate } from '../../../../utils/breathe/animate';
import { breatheKey } from '../../../../constants/routeKeys';
import { buildExerciceSteps } from '../../../../utils/breathe/buildExerciceSteps';
import { client } from '../../../../config/apollo/client';
import { concatPath } from '../../../../utils/links/concatPath';
import { isAndroid, isWeb } from '../../../../config/designSystem/Layout';
import { logAmplitude } from '../../../../utils/analytics/analytics';
import { observer } from 'mobx-react';
import { router, useFocusEffect } from 'expo-router';
import { useAvailableDimensions } from '../../../../hooks/ui/useAvailableDimensions';
import { useKeepAwake } from 'expo-keep-awake';
import { useStores } from '../../../../hooks/useStores';






const unmountAnimDuration = 300;

export const Exercice = observer(() => {
  const rootStore = useStores();
  useKeepAwake();

  const technique = rootStore?.technique.getTechnique;
  const timerDuration= rootStore?.technique.getTimerDuration*60000;
  const stepVibrationFlag = rootStore?.technique.getStepVibrationFlag;
  const guidedBreathingMode = rootStore?.technique.getGuidedBreathingMode;
  const techniqueIndex = rootStore?.technique.getTechniqueIndex;
  const [techniqueIndexModule5, setTechniqueIndexModule5] = useState(techniqueIndex);
  const [status, setStatus] = React.useState('interlude');
  const [unmountContentAnimVal, setUnmountContentAnimVal] = React.useState(new Animated.Value(1));
  const steps = buildExerciceSteps(technique.durations);

  const [soundBell, setSoundBell] = useState<SoundHandle | undefined>(undefined);
  const holdPath = rootStore.technique.soundPath('bell', 'BreatheOut');

  const {height, width} = useAvailableDimensions();
  const HEIGHT_NAVIGATOR = isWeb? 0: HEIGHT_BOTTOM_TAB_BAR;

  const buttonAnimatorContentHeight = height - HEIGHT_NAVIGATOR-  buttonSize * 1.5;

  const unmountContentAnimation = animate(unmountContentAnimVal, {
    toValue: 0,
    duration: unmountAnimDuration,
  });

  const handleInterludeComplete = () => {
    setStatus('running');
  };

  const preloadBellSound = async () => {
    setSoundBell(await preloadSound(holdPath));

  };

  const goToSelector = () => {
    router.navigate(concatPath([breatheKey]));
  };

  useEffect(() => {
    preloadBellSound();
    return () => {
      if(status === 'completed') setStatus('interlude');
      logAmplitude('Activity Finished', {
        activityType: 'breathing',
        activityId: technique?.humanReadableId,
      });
    };
  }, []);

  useFocusEffect(() => {
    return () => {
      if(status === 'completed') {
        setStatus('interlude');
        setUnmountContentAnimVal(new Animated.Value(1));
      }
    };
  });

  const handleTimeLimitReached = () => {
    unmountContentAnimation.start(({ finished }) => {
      if (finished) {
        if (guidedBreathingMode !== 'disabled') playSound(soundBell);
        setStatus('completed');
        client.mutate({
          mutation: CREATE_USER_EVENT,
          fetchPolicy:'no-cache',
          variables: {
            input: {
              type:'BreathingFinished',
              entityId:technique?._id
            }
          }
        });
      }
    });
  };


  useEffect(() => {
    setTechniqueIndexModule5(techniqueIndex%LEFT_BREATHING_COLORS.length);
  }, [techniqueIndex]);

  const contentAnimatedStyle = {
    opacity: unmountContentAnimVal,
  };

  return (
    <LinearGradient start={{x:0,y:0}} end={{x:1,y:0}} colors={[LEFT_BREATHING_COLORS[techniqueIndexModule5],RIGHT_BREATHING_COLORS[techniqueIndexModule5]]}
      style={[
        styles.gradient,
        {
          width,
          height}]} >
      <StatusBar style="light" />

      {status === 'interlude' && (
        <ExerciceInterlude onComplete={handleInterludeComplete} />
      )}
      {status === 'running' && (
        <Animated.View style={[{height:buttonAnimatorContentHeight}, contentAnimatedStyle,  !isAndroid && { zIndex:-1}, isAndroid && {zIndex:1}]}>

          <ExerciceCircle
            steps={steps}
            guidedBreathingMode={guidedBreathingMode}
            vibrationEnabled={stepVibrationFlag}
          />
          <ExerciceTimer
            limit={timerDuration}
            onLimitReached={handleTimeLimitReached}
          />
        </Animated.View>
      )}
      {status === 'completed'  && <ExerciceComplete />}
    </LinearGradient>
  );
});


const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  gradient: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  },
});

export default Exercice;